import React from "react";

import loginImg from "../../assets/app_screenshots/login.jpeg";
import homeImg from "../../assets/app_screenshots/home.jpeg";
import chapterImg from "../../assets/app_screenshots/chapter.jpeg";
import kunjiChatImg from "../../assets/app_screenshots/kunji_chat.jpeg";
import mcqImg from "../../assets/app_screenshots/mcq.jpeg";
import shortAnswerImg from "../../assets/app_screenshots/short_answer.jpeg";
import modelTestImg from "../../assets/app_screenshots/model_test.jpeg";
import progressImg from "../../assets/app_screenshots/progress.jpeg";
import leaderboardImg from "../../assets/app_screenshots/leaderboard.jpeg";
import premiumImg from "../../assets/app_screenshots/premium.jpeg";

const slots = [
  { key: "login", src: loginImg, label: "लॉग इन करें" },
  { key: "home", src: homeImg, label: "सब फ़ीचर एक जगह" },
  { key: "chapter", src: chapterImg, label: "वीडियो लेसन + नोट्स" },
  { key: "kunji", src: kunjiChatImg, label: "कुंजी AI से चैट" },
  { key: "mcq", src: mcqImg, label: "MCQ अभ्यास" },
  { key: "short", src: shortAnswerImg, label: "लघु उत्तरीय का AI हल" },
  { key: "model", src: modelTestImg, label: "मॉडल टेस्ट पेपर" },
  { key: "progress", src: progressImg, label: "पढ़ाई की प्रगति" },
  { key: "leaderboard", src: leaderboardImg, label: "लीडरबोर्ड + रैंक" },
  { key: "premium", src: premiumImg, label: "प्रीमियम अपग्रेड" },
];

const ScreenshotCarousel = () => {
  return (
    <section
      aria-label="App screenshots"
      className="py-14 px-4 bg-white"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            ऐप कैसा दिखता है
          </h2>
          <p className="mt-2 text-gray-600">
            लॉग इन से लेकर doubts solve करने और रैंक पाने तक — पूरा सफ़र।
          </p>
        </div>
        <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 -mx-4 px-4">
          {slots.map((s, i) => (
            <div
              key={s.key}
              className="flex-shrink-0 w-48 sm:w-56 snap-center"
            >
              <div className="relative rounded-2xl border border-gray-200 shadow-sm overflow-hidden bg-gray-50">
                <span className="absolute top-2 left-2 z-10 bg-orange-500 text-white text-xs font-semibold rounded-full w-6 h-6 flex items-center justify-center">
                  {i + 1}
                </span>
                <img
                  src={s.src}
                  alt={`Pathyacharya app — ${s.label}`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto block"
                />
              </div>
              <p className="mt-2 text-xs sm:text-sm text-gray-700 text-center font-medium">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScreenshotCarousel;
